import { generateClient } from 'aws-amplify/api';
import { listLocations } from "../graphql/customQueries";

const client = generateClient();

export default async (limit = 10) => {
    try {
        const {
            data: { listLocations: locations },
        } = await client.graphql({
            query: listLocations,
            variables: {
                limit,
            },
        });
        return locations;
    } catch (ex) {
        console.error("failed to list locations", ex);
    }
};
